import { render, staticRenderFns } from "./AfaList.vue?vue&type=template&id=6ca719a2"
import script from "./AfaList.vue?vue&type=script&lang=js"
export * from "./AfaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports